import React from 'react'
import { observer } from 'mobx-react-lite'
import { type IIconButtonColor } from 'shared/ui'
import type { ZIndex } from 'shared/constants/zIndex'
import { useMessageFieldContext } from 'widgets/MessageField/context/MessageFieldContext'
import { EmojiPicker } from 'widgets/MessageField/ui/EmojiPicker/EmojiPicker'

type IEmojiActionProps = {
  iconColor?: IIconButtonColor
  zIndex?: ZIndex
}

export const EmojiAction: React.FC<IEmojiActionProps> = observer(({ iconColor, zIndex }) => {
  const messageFieldStore = useMessageFieldContext()

  const onTrigger = () => {
    if (messageFieldStore.isVariantNote) {
      messageFieldStore.setActiveMessageField(true)
    }
  }

  return (
    <EmojiPicker
      messageFieldStore={messageFieldStore}
      iconColor={iconColor}
      onTrigger={onTrigger}
      zIndex={zIndex}
    />
  )
})
